import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { QA_NAME_SAVE_BTN } from '../../../constants/qa'
import { SIZE } from '../../../constants/size'
import { FormModal } from '../../Form'

import { QA_NAME_REQUEST_EDIT_LABEL_FORM_MODAL } from './RequestEditLabelModal.constants'
import {
  getRequestEditLabelModalPayload,
  getRequestEditLabelModalValidationSchema,
} from './RequestEditLabelModal.utils'
import { RequestEditLabelModalFields } from './RequestEditLabelModalFields'

function RequestEditLabelModal({
  initialValues,
  itemAction,
  onSubmit,
  ...restProps
}) {
  const validationSchema = getRequestEditLabelModalValidationSchema(
    initialValues,
    itemAction
  )

  function handleSubmit({ values }) {
    onSubmit({ payload: getRequestEditLabelModalPayload(values), values })
  }

  const formBodyProps = {
    ...FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION,
    submitQaName: QA_NAME_SAVE_BTN,
  }

  return (
    <FormModal
      {...restProps}
      Fields={RequestEditLabelModalFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: QA_NAME_REQUEST_EDIT_LABEL_FORM_MODAL,
      }}
      formBodyProps={formBodyProps}
      formTitle='Modal.EditLabelTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditLabelModal
